import { render, staticRenderFns } from "./cModalAdComment.vue?vue&type=template&id=ede6300c&scoped=true"
import script from "./cModalAdComment.vue?vue&type=script&lang=js"
export * from "./cModalAdComment.vue?vue&type=script&lang=js"
import style0 from "./cModalAdComment.vue?vue&type=style&index=0&id=ede6300c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede6300c",
  null
  
)

export default component.exports